import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { getArticleGroupNumberString } from "@msuite/utils/stock";
import type { ArticleGroupListItem } from "@msuite/utils/types";
import { NoteText } from "@/components/notes";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<ArticleGroupListItem>();

export const columns = [
	columnHelper.accessor((row) => getArticleGroupNumberString(row.number), {
		id: "number",
		header: localized("stock.order_no"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("name", {
		id: "name",
		header: localized("general.name"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("description", {
		id: "description",
		header: localized("general.description"),
		cell: (cell) => <NoteText note={cell.getValue()} />,
		size: 350,
	}),
	columnHelper.accessor("articleProductTypeCount", {
		id: "articleProductTypeCount",
		header: localized("stock.article_product_types"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("articleCount", {
		id: "articleCount",
		header: localized("stock.articles"),
		cell: (cell) => cell.getValue(),
	}),
	createRowActions(RowActions),
];
